"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    margin: auto;\n    max-width: ", ";\n    ", ";\n"], ["\n    margin: auto;\n    max-width: ", ";\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n            padding: 0 ", "em;\n        "], ["\n            padding: 0 ", "em;\n        "]),
    _templateObject3 = _taggedTemplateLiteral(["\n    clear: both;\n"], ["\n    clear: both;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactEqualizer = require("react-equalizer");

var _reactEqualizer2 = _interopRequireDefault(_reactEqualizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents2.default.div(_templateObject, function (props) {
    return props.expanded ? "100%" : props.width + "px";
}, function (props) {
    return !props.collapse && (0, _styledComponents.css)(_templateObject2, function (props) {
        return props.theme.row.padding / 2;
    });
});

var Clear = _styledComponents2.default.div(_templateObject3);

var Row = function (_React$Component) {
    _inherits(Row, _React$Component);

    function Row() {
        _classCallCheck(this, Row);

        return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
    }

    _createClass(Row, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                equaliseChildHeight = _props.equaliseChildHeight,
                equaliseByRow = _props.equaliseByRow,
                rest = _objectWithoutProperties(_props, ["children", "equaliseChildHeight", "equaliseByRow"]);
            //NOTE - The ternary operator is being used below as the 'enabled' prop on the Equalizer didn't seem
            //to revert after being set back to false from true...


            return _react2.default.createElement(
                StyledRow,
                rest,
                this.props.equaliseChildHeight ? _react2.default.createElement(
                    _reactEqualizer2.default,
                    { byRow: equaliseByRow },
                    children,
                    _react2.default.createElement(Clear, null)
                ) : _react2.default.createElement(
                    "div",
                    null,
                    children,
                    _react2.default.createElement(Clear, null)
                )
            );
        }
    }]);

    return Row;
}(_react2.default.Component);

Row.displayName = "Row";

Row.propTypes = {
    /** The width of the row */
    width: _propTypes2.default.number,
    /** Boolean indicating whether the row should be 100% width */
    expanded: _propTypes2.default.bool,
    /** Boolean indicating whether the row should have padding */
    collapse: _propTypes2.default.bool,
    /** Boolean indicating whether the row should equalise the heights of child elements */
    equaliseChildHeight: _propTypes2.default.bool,
    /** Boolean indicating whether child elements stacking should be considered when equalising (https://github.com/patrickgalbraith/react-equalizer#options) */
    equaliseByRow: _propTypes2.default.bool
};

Row.defaultProps = {
    width: 1400,
    expanded: false,
    collapse: false,
    equaliseChildHeight: false,
    equaliseByRow: true
};

exports.default = Row;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/row.js
// module id = 213
// module chunks = 95715928098905 168707334958949